import { useMemo, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { TextsProvider } from "@digitalisation/enlixy-comp";
import { cockpitTexts } from "./cockpitTexts";

/**
 * Texts of the shared components (@digitalisation/enlixy-comp) in the
 * cockpit's language: the package's German, English and French texts
 * (textsFor), German in the formal "Sie" (cockpitTexts). Without this
 * provider its components would show German whatever language the user
 * picked. useTranslation re-renders on i18n.changeLanguage, so the texts
 * follow the header's language selector.
 */
export function AppTextsProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage ?? i18n.language;
  const texts = useMemo(() => cockpitTexts(language), [language]);
  return <TextsProvider texts={texts}>{children}</TextsProvider>;
}
